import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import VideoLibrary from '@material-ui/icons/VideoLibrary';
import { Player, ControlBar, VolumeMenuButton, ReplayControl, ForwardControl, PlaybackRateMenuButton } from 'video-react';
import HLSSource from './HLSSource';
import Notifier, { openSnackbar } from './notifier';

import api from '../api/backend'

import { isBrowser } from "react-device-detect";

import ReactGA from 'react-ga';

const styles = {
    appBar: {
        position: 'relative',
    },
    flex: {
        flex: 1,
    },
};

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class ViewVideo extends React.Component {
    state = {
        open: false,
    };

    handleClickOpen = () => {
        const { path } = this.props;
        this.setState({ open: true });
        ReactGA.initialize('UA-141674580-1')
        ReactGA.event({
            category: 'Video',
            action: `Open Video [${path}]`
          })
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    addHistory = () => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const { videoId, onAddHistory, viewOnly } = this.props

        if (!viewOnly) {
            api.addHistory({ user: user.userName, videoId: videoId }).then(([response, json]) => {
                if (response.status === 200) {
                    if (onAddHistory) {
                        onAddHistory()
                    }
                } else {
                    console.error('ไม่สามารถลบการลงทะเบียนได้')
                }
            }).catch(() => {
                console.error('ไม่สามารถเชื่อมต่อ service ได้')
            })
        }
    }

    render() {
        const { videoId, path, title, duration, disabled } = this.props;
        return (
            <React.Fragment>
                <Notifier />
                {disabled ? <Grid item onClick={() => openSnackbar({ message: 'จำนวนครั้งที่สามารถดูได้ครบแล้ว ต้องการดูเพิ่มกรุณาติดต่อสำนักงาน' })} style={{ cursor: 'pointer' }}>
                    <VideoLibrary />
                </Grid> : <Grid item onClick={this.handleClickOpen} style={{ cursor: 'pointer' }}>
                        <VideoLibrary />
                    </Grid>}
                <Dialog
                    open={this.state.open}
                    TransitionComponent={Transition}
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
                    <DialogContent>
                        <Player autoPlay={isBrowser ? false : true}>
                            <HLSSource
                                isVideoChild
                                // src={`${process.env.REACT_APP_VOD}/hls819/videos/${videoId}/master.m3u8`}
                                // src={`${process.env.REACT_APP_VOD}/hls819/${path}/master.m3u8`}
                                // src={`${process.env.REACT_APP_VOD}:8081/${path}/playlist.m3u8`}
                                src={`/${path}/playlist.m3u8`}
                                duration={duration} onTick={() => this.addHistory()}
                            // src={`${process.env.REACT_APP_BAKEND}/api/videos/${videoId}/play`}
                            />
                            <ControlBar>
                                <ReplayControl seconds={10} order={1.1} />
                                <ForwardControl seconds={30} order={1.2} />
                                <PlaybackRateMenuButton order={11}/>
                                <VolumeMenuButton order={12}/>
                            </ControlBar>
                        </Player>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            ปิดวีดีโอ
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(ViewVideo);